
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import {detectBrowser} from './browser/detectBrowser';

export const getBrowserMetadata = () => {
    const hasNavigator = typeof navigator !== 'undefined';
    const hasWindow = typeof window !== 'undefined';
    const userAgent = hasNavigator ? navigator.userAgent : '';

    return {
        browser: detectBrowser(userAgent),
        userAgent,
        language: hasNavigator ? navigator.language : '',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        screenResolution: hasWindow ? `${window.screen.width}x${window.screen.height}` : null,
        colorDepth: hasWindow ? window.screen.colorDepth : null,
        platform: hasNavigator ? navigator.platform : '',
        connectionType: hasNavigator ? navigator?.connection?.effectiveType || null : null,
        connectedAt: new Date().toISOString(),
    };
};

export const buildAuthPayload = async (email, tenantId) => {
    // Generar device ID estable
    const fp = await FingerprintJS.load();
    const { visitorId } = await fp.get();

    return {
        token: email,
        tenantId,
        deviceId: visitorId,        // para detectar sesiones duplicadas después
        metadata: getBrowserMetadata() // para auditoría ahora
    };
};
